// Cari KPI kartları (Toplam Borç / Toplam Ödenen / Net Bakiye) — AcikBorc ledger
// aggregat'larından hesaplanır. ledgerRows: [{fatura_toplam, gider_toplam, odenen_toplam}]
// (TUMU görünümü: cariBalances; firma görünümü: firmaBalances.items değerleri).
//
// Neden ledger (ham faturalar/gider_borclar DEĞİL): ham faturalar tablosu İPTAL
// faturaları da içerir ve eski hesap onları borç sayıp Net Bakiye'yi şişiriyordu;
// ayrıca Toplam Borç kartı gideri dışlıyordu → "Borç − Ödenen ≠ Net" tutarsızlığı.
// Ledger (acik_borclar) İPTAL'i yazmaz ve fatura+gider'i birleştirir; per-tedarikçi
// liste + firma görünümü zaten bunu kullanır → tek kaynak.
//
// TUMU görünümünde odenen_toplam = ham Σ Odeme (gerçek ödenen) → netBakiye gerçek
// net (fazla ödeme negatif olabilir, artık 'Σ kalan açık' DEĞİL). Firma görünümünde
// odenen ledger-türevli (Σ odenen_tutar) kalır (ödeme firma-bağsız).
// Invariant (her iki görünümde): toplamBorc − toplamOdenen = netBakiye.
export function hesaplaCariKpi(ledgerRows) {
  const rows = Array.isArray(ledgerRows) ? ledgerRows : [];
  const toplamFatura = rows.reduce((s, r) => s + (r.fatura_toplam || 0), 0);
  const toplamGiderBorc = rows.reduce((s, r) => s + (r.gider_toplam || 0), 0);
  const toplamOdenen = rows.reduce((s, r) => s + (r.odenen_toplam || 0), 0);
  const toplamBorc = toplamFatura + toplamGiderBorc;
  return {
    toplamFatura,
    toplamGiderBorc,
    toplamOdenen,
    toplamBorc,
    netBakiye: toplamBorc - toplamOdenen,
  };
}
